<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="3" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        subtitle:'FLASH Therapy',
        videosrc:'P05.mp4',
        title:'FLASH質子閃射療法',
        list:[
          {
            body:"FLASH閃射療法目前是一種實驗性療法，可在不到一秒內以超高劑量率完成放射治療照射。FLASH閃射療法象徵未來癌症治療的潛在重大進步，FLASH效應已在使用質子和電子的臨床前實驗中得到證實；FLASH在動物模型中的臨床前研究表示，使用超高劑量率的輻射，可能有效治療腫瘤，同時減低周圍健康組織的毒性。目前的研究結果傾向於指出40Gy/s是觀察到FLASH效應的劑量率下限。因此，FLASH也特指劑量率達到或超過此特定限制並產生某些FLASH相關效應的放射治療。更廣泛的超高劑量率放射治療稱為UHDR-RT。<br><br>與FLASH相關的基礎研究發現，與常規劑量率放療相比，FLASH引起的正常組織毒性有可能降低。這已在多個器官系統中觀察到，包括小鼠、斑馬魚、貓和迷你豬。FLASH效應的臨床意義在於它可以有機會提升患者的腫瘤治療效果，減少放療的副作用。FLASH療法可能是幾十年來癌症治療中最重要的進步之一。"

          }

        ]
      }

    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
